import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ScfdDocModel } from '../../Models/Models/Instruments/ScfdDocModel';
import { SCFDDocQuery } from '../../Models/Domains/Investment/SCFDDocQuery';

declare var IS_RUNNING_IN_APP_POOL;

export class SCFDDocClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(query: SCFDDocQuery): Promise<Array<ScfdDocModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Instruments/SCFDDoc/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { query: query }

    return AjaxWrapper.post<Array<ScfdDocModel>, any>(url, data);
  }
}

